export const CRM_READ_PERM = 'crm:account:read'
export const CRM_WRITE_PERM = 'crm:account:write'
export const CRM_MEETING_READ_PERM = 'crm:meeting:read'
export const CRM_MEETING_WRITE_PERM = 'crm:meeting:write'
export const CRM_FINANCE_READ_PERM = 'crm:finance:read'
export const CRM_FINANCE_PERM = ['crm:finance:payment:write', 'crm:finance:invoice:write']
export const CRM_MAIL_READ_PERM = 'crm:mail:read'
export const CRM_FILE_READ_PERM = 'crm:file:read'
export const CRM_FILE_WRITE_PERM = 'crm:file:write'
export const CRM_NOTE_WRITE_PERM = 'crm:note:write'
export const CRM_MAIL_SEND_PERM = 'crm:mail:send'
/** Mail modülünden gönderim (kişinin şirket mail hesabı). */
export const MAIL_SEND_PERM = 'mail:user:write'
